import { useCallback } from "react";
import styled from "styled-components";
import {
  BASIC_DARK_GRAY,
  BASIC_LIGHT_BLUE,
  BASIC_LINE,
} from "../../constants/colors";

type Props = {
  name: string;
  text: string;
  selected?: boolean;
  image?: string;
  imageWidth?: number;
  imageHeight?: number;
  onChange?: () => void;
};

export const RadioButton: React.FC<Props> = ({
  name,
  onChange,
  selected,
  text,
  image,
  imageWidth,
  imageHeight,
}) => {
  const handleOnChange = useCallback(() => {
    if (selected) return;

    onChange?.();
  }, [selected]);

  return (
    <RadioButtonWrapper selected={selected ?? false} onClick={handleOnChange}>
      <StyledRadioButton
        type="radio"
        name={name}
        checked={selected}
        onChange={() => {}}
      />
      <RadioButtonLabel>{text}</RadioButtonLabel>

      {image && (
        <IconsContainer>
          <StyledIcon
            src={image}
            alt=""
            width={imageWidth}
            height={imageHeight}
          />
        </IconsContainer>
      )}
    </RadioButtonWrapper>
  );
};

const RadioButtonWrapper = styled.div<{
  selected: boolean;
}>`
  position: relative;
  text-align: left;
  border: 2px solid
    ${({ selected }) => (selected ? BASIC_LIGHT_BLUE : BASIC_LINE)};
  border-radius: 4px;
  padding: 28px 18px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
`;

const StyledRadioButton = styled.input`
  position: absolute;
  left: -9999px;
  &:checked + label {
    color: ${BASIC_LIGHT_BLUE};
    &:before {
      border-color: ${BASIC_LIGHT_BLUE};
    }
    &:after {
      opacity: 1;
      transform: scale(1);
    }
  }
  &:not(:checked) + label {
    color: ${BASIC_DARK_GRAY};
  }
`;

const RadioButtonLabel = styled.label`
  font-size: 18px;
  font-weight: 600;
  position: relative;
  padding-left: 32px;
  cursor: pointer;
  display: inline-block;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid ${BASIC_LINE};
  }
  &:after {
    content: "";
    width: 12px;
    height: 12px;
    background: ${BASIC_LIGHT_BLUE};
    position: absolute;
    top: 9px;
    left: 6px;
    border-radius: 50%;
    opacity: 0;
    transform: scale(0);
    transition: all 0.2s ease;
  }
`;

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

const StyledIcon = styled.img`
  width: auto;
  object-fit: contain;
`;
